import React from 'react'
import MenuSection from '../menu-section/MenuSection'
import Cart from '../cart/Cart'
import { API_URL } from '../constants'
import axios from 'axios'
import {connect} from 'react-redux'
import { getPickupDate, getCartItems } from '../redux/selectors'
import { setIsMenuActive } from '../redux/actions'
import { Redirect, withRouter } from 'react-router-dom'
import { slugify } from '../utilities'
import { Link, Events } from 'react-scroll'
import SiteBanner from '../site-banner/SiteBanner';

class Menu extends React.Component {
  state = {
    menu: [],
    products: {},
    carts: [],
    orders: [],
    menuItemAddedDate: null,
    goToReview: false
  }

  updateMenuData = () => {
    axios.get(API_URL + '/menu')
      .then(response => this.setState({
        menu: response.data
      }))
      axios.get(API_URL + '/products',  {
          params: {
            date: this.props.pickupDate
          }
      })
      .then(response => {
        let products = {}
        //Set the used on the products
        let productsArray = response.data.products.map(product =>{
          if(product.availability) {
            let stock = product.availability.stock
            let slug = product.slug
            let orderUsed = response.data.orders.reduce((acc, order) => {
                let used = 0
                if(order.slug === slug) {
                  used = order.used
                }
                return acc + used
              }, 0)
            let cartUsed = response.data.carts.reduce((acc, cart) => {
                let used = 0
                if(cart.slug === slug) {
                  used = cart.used
                }
                return acc + used
            }, 0)
            return {
              ...product,
              availability: {
                stock: (stock - orderUsed - cartUsed)
              }
            }
          }
          return product
        })
        //Set the data up as an object for fast lookup
        for(let product of productsArray) {
          products[product.slug] = { ...product }
        }
        return this.setState({
          products,
          orders: response.data.orders,
          carts: response.data.carts
        })
      })
  }

  onMenuItemAdded = () => this.setState({
    menuItemAddedDate: new Date()
  })

  componentDidMount() {
    this.updateMenuData();
    this.props.setIsMenuActive(true)
    Events.scrollEvent.register('begin', function(to, element) {
      // Hide the menu when scrolling starts
      document.body.classList.remove('show_nav_menu');
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.menuItemAddedDate !== this.state.menuItemAddedDate) {
      // Update the menu
      this.updateMenuData();
    }
  }

  onReviewClick = () => {
    this.props.setIsMenuActive(false)
    this.setState({
      goToReview: true
    })
  }
 
  render() {
    if(this.state.goToReview) {
      return <Redirect push to="/review" />
    }
    let menuData = this.state.menu.map((item, index) => <li key={index}><Link activeClass="active" to={slugify(item.title)} spy={true} smooth={true} offset={-50} duration={700}>{item.title}</Link></li>)
    return (
      <React.Fragment>
          <nav>
            <div className="page-container">
              <ul>
                { menuData }
              </ul>
              <ul>
                <li><a href="http://franklinbarbecue.com/">Franklinbbq.com</a></li>
                <li><a href="https://shop.franklinbbq.com">Shop</a></li>
              </ul>
            </div>
        </nav>
        <main>
          <div className="page-container">
            <SiteBanner />
          </div>
          {this.state.menu.map((item, index) => <MenuSection key={index} items={item} onMenuItemAdded={this.onMenuItemAdded} products={this.state.products} />)}
        </main>
        <Cart onCartItemRemoved={this.onMenuItemAdded} />
        <div className="mobile-cta">
          <div className="fixed-area">
            <div className="page-container">
              <button onClick={this.onReviewClick} className={`${this.props.cartItems.length === 0 ? 'is_disabled' : ''} button button-large button-page`}>Review order</button>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const pickupDate = getPickupDate(state)
  const cartItems = getCartItems(state)
  return {
    pickupDate,
    cartItems
  }
}

export default withRouter(connect(mapStateToProps, { setIsMenuActive })(Menu));
